import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../actions';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import ReportHwEntity from '../../../../entity/ReportHwEntity';
import __ from 'lodash';
import Loader from '../../../Loader';
import LoaderModal from '../../../modal/LoaderModal';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
// import './homeworkReport.css';
import logo_eduprime from './images/eduprime_tulisan_hitam.png';

class ReportHomeworkDetailJawaban extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isFetching: false,
            isLoading: false,
            dialogShow: false,
            alertShow: false,
            alertMessage: '',
            idAdmin: null,
            idProvinsi: null,
            idDinas: null,
            namaDinas: null,
            dataKelas: null,
            dataSubProfil: {},
            dataGuru: {},
            dataAllSiswa: [],
            dataKunciJawaban: [],
            detailJawaban: [],
        };
    }

    async componentDidMount() {
        console.clear();
        console.time("Time componentDidMount");
        this.setState({
            isFetching: true
        });
        await this.props.cekCookies();

        console.groupCollapsed('componentDidMount');
        console.info('CEK ACCOUNT', this.props.account);
        console.info('PARAM 1',  this.props.match.params.idProfil);
        console.info('PARAM 2',  this.props.match.params.idJadwalProfil);
        console.info('PARAM 3',  this.props.match.params.idKp);
        console.info('PARAM 4', this.props.match.params.ta1 + '/' + this.props.match.params.ta2);
        console.groupEnd();
        
        if(!__.isEmpty(this.props.account)) {
            this.setState({
                idAdmin: this.props.account.idAdmin,
                idProvinsi: this.props.account.idProvinsi,
                idDinas: this.props.account.idDinas,
                namaDinas: this.props.account.namaUser,
            });

            // Fetch Report Homework by Kelasparalel
            const fetchReportHwDetail = await accountManagement.post(CONFIG.HW_REPORT_BY_DETAIL_JAWABAN, {...ReportHwEntity,
                idProfil: this.props.match.params.idProfil,
                idKp: this.props.match.params.idKp,
                idJadwalProfil: this.props.match.params.idJadwalProfil,
                kodeTa: this.props.match.params.ta1 + '/' + this.props.match.params.ta2,
            })
            .catch(function(error) {
                console.error('ERROR HW_REPORT_BY_DETAIL_JAWABAN', error);
            });
            console.info('Response fetchReportHwDetail', fetchReportHwDetail);
            
            // Set State Report Homework by Kelasparalel
            if(fetchReportHwDetail.request.readyState === 4 && fetchReportHwDetail.status === 200) {
                console.info('CEK fetchReportHwDetail', fetchReportHwDetail);
                if(fetchReportHwDetail.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    this.setState({
                        dataKelas: fetchReportHwDetail.data.data.dataKelas,
                        dataSubProfil: fetchReportHwDetail.data.data.dataSubProfil,
                        dataGuru: fetchReportHwDetail.data.data.dataGuru,
                        dataAllSiswa: fetchReportHwDetail.data.data.dataSiswa,
                        dataKunciJawaban: fetchReportHwDetail.data.data.dataKunciJawaban,
                        detailJawaban: fetchReportHwDetail.data.data.detailJawaban,
                    });
                }
            }
        }

        this.setState({
            isFetching: false
        });
        console.timeEnd("Time componentDidMount");
    }

    loading = () => {
        if(this.state.isLoading) {
            return(
                <Loader />
            )
        }
    }

    showAlert = () => {
        if(this.state.alertShow) {
            return(
                <Alert severity="info"
                    action={
                        <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => this.setState({alertShow:false})}
                        >
                        <i class="fa fa-times" aria-hidden="true"></i>
                        </IconButton>
                    }
                    >
                    <strong>{ this.state.alertMessage }</strong>
                </Alert>
            )
        }
    }
    
    renderHeadKunciJawaban() {
        let sumKunciJawaban = this.state.dataKunciJawaban.length;

        return (
            <thead>
                <tr>
                    <th className="th-title v-align-center" scope="col" rowSpan="2">#</th>
                    <th className="th-title v-align-center" scope="col" rowSpan="2">KUNCI JAWABAN</th>
                    <th className="th-title v-align-center" scope="col" colSpan={ sumKunciJawaban }>ITEM SOAL</th>
                </tr>
                <tr>
                    {
                        this.state.dataKunciJawaban.map((valueKunci, indexKunci) => {
                            return (
                                <th key={indexKunci} className="th-title v-align-center" scope="col">{ indexKunci + 1 }</th>
                            )
                        })
                    }
                </tr>
            </thead>
        )
    }

    renderBodyKunciJawaban() {
        /*
        let kunci;

        let kunciJawaban = this.state.dataKunciJawaban.map((itemKunci, indexKunci) => {
            console.groupCollapsed('CEK KUNCI JAWABAN');
            console.info(itemKunci.KUNCI_JAWABAN);
            if(itemKunci.KUNCI_JAWABAN === "1") {
                // kunci = "A";
                kunci = <td key={itemKunci.ID_BANK_SOAL} data-attr-id={itemKunci.ID_BANK_SOAL} style={{ textAlign: 'center' }}>A</td>
            }
            else if (itemKunci.KUNCI_JAWABAN === "2") {
                // kunci = "B";
                kunci = <td key={itemKunci.ID_BANK_SOAL} data-attr-id={itemKunci.ID_BANK_SOAL} style={{ textAlign: 'center' }}>B</td>
            }
            else if (itemKunci.KUNCI_JAWABAN === "3") {
                // kunci = "C";
                kunci = <td key={itemKunci.ID_BANK_SOAL} data-attr-id={itemKunci.ID_BANK_SOAL} style={{ textAlign: 'center' }}>C</td>
            }
            else if (itemKunci.KUNCI_JAWABAN === "4") {
                // kunci = "D";
                kunci = <td key={itemKunci.ID_BANK_SOAL} data-attr-id={itemKunci.ID_BANK_SOAL} style={{ textAlign: 'center' }}>D</td>
            }
            else {
                // kunci = "E";
                kunci = <td key={itemKunci.ID_BANK_SOAL} data-attr-id={itemKunci.ID_BANK_SOAL} style={{ textAlign: 'center' }}>E</td>
            }
            console.info('Return ' + (indexKunci + 1), kunci);
            console.groupEnd();
        });
        */

        return (
            <tbody>
                <tr>
                    <td className="text-body center">&nbsp;</td>
                    <td className="text-body center" >&nbsp;</td>
                    {
                        this.state.dataKunciJawaban.map((itemKunci, indexKunci) => {
                            if(itemKunci.KUNCI_JAWABAN === "1") {
                                return (
                                    <td key={itemKunci.ID_BANK_SOAL} className="text-body center" data-attr-id={itemKunci.ID_BANK_SOAL}>A</td>
                                )
                            }
                            else if (itemKunci.KUNCI_JAWABAN === "2") {
                                return (
                                    <td key={itemKunci.ID_BANK_SOAL} className="text-body center" data-attr-id={itemKunci.ID_BANK_SOAL}>B</td>
                                )
                            }
                            else if (itemKunci.KUNCI_JAWABAN === "3") {
                                return (
                                    <td key={itemKunci.ID_BANK_SOAL} className="text-body center" data-attr-id={itemKunci.ID_BANK_SOAL}>C</td>
                                )
                            }
                            else if (itemKunci.KUNCI_JAWABAN === "4") {
                                return (
                                    <td key={itemKunci.ID_BANK_SOAL} className="text-body center" data-attr-id={itemKunci.ID_BANK_SOAL}>D</td>
                                )
                            }
                            else {
                                return (
                                    <td key={itemKunci.ID_BANK_SOAL} className="text-body center" data-attr-id={itemKunci.ID_BANK_SOAL}>E</td>
                                )
                            }
                        })
                    }
                </tr>
            </tbody>
        );
    }
    
    renderHeadJawabanSiswa() {
        const lengthKunciJawaban = this.state.dataKunciJawaban.length;

        return (
            <thead>
                <tr>
                    <th className="th-title v-align-center" scope="col" rowSpan="2">No</th>
                    <th className="th-title v-align-center" scope="col" rowSpan="2">NAMA SISWA</th>
                    <th className="th-title v-align-center" scope="col" colSpan={ lengthKunciJawaban }>ITEM SOAL</th>
                </tr>
                <tr>
                    {
                        this.state.dataKunciJawaban.map((valueKunci, indexKunci) => {
                            return (
                                <th key={indexKunci} className="th-title v-align-center" scope="col">{ indexKunci + 1 }</th>
                            )
                        })
                    }
                </tr>
            </thead>
        )
    }

    renderBodyJawabanSiswa() {
        return(
            <tbody>
                {
                    this.state.dataAllSiswa.map((itemSiswa, indexSiswa) => {
                        return (
                            <tr key={indexSiswa}>
                                <td className="styles.text-body center" >{ indexSiswa + 1 }</td>
                                <td className="styles.text-body left" >{ itemSiswa.NAMA_SISWA}</td>
                                {
                                    this.state.detailJawaban.map((itemJawaban, indexJawaban) => {
                                        if(itemJawaban.ID_SISWA === itemSiswa.ID_SISWA) {
                                            if(itemJawaban.JAWABAN_SISWA === "1") {
                                                return (
                                                    <td key={indexJawaban} className={itemJawaban.STATUS_JAWABAN === '1' ? 'text-body center green' : 'text-body center red'} data-attr-id={itemJawaban.ID_BANK_SOAL} style={{ textAlign: 'center' }}>A</td>
                                                )
                                            }
                                            else if (itemJawaban.JAWABAN_SISWA === "2") {
                                                return (
                                                    <td key={indexJawaban} className={itemJawaban.STATUS_JAWABAN === '1' ? 'text-body center green' : 'text-body center red'} data-attr-id={itemJawaban.ID_BANK_SOAL} style={{ textAlign: 'center' }}>B</td>
                                                )
                                            }
                                            else if (itemJawaban.JAWABAN_SISWA === "3") {
                                                return (
                                                    <td key={indexJawaban} className={itemJawaban.STATUS_JAWABAN === '1' ? 'text-body center green' : 'text-body center red'} data-attr-id={itemJawaban.ID_BANK_SOAL} style={{ textAlign: 'center' }}>C</td>
                                                )
                                            }
                                            else if (itemJawaban.JAWABAN_SISWA === "4") {
                                                return (
                                                    <td key={indexJawaban} className={itemJawaban.STATUS_JAWABAN === '1' ? 'text-body center green' : 'text-body center red'} data-attr-id={itemJawaban.ID_BANK_SOAL} style={{ textAlign: 'center' }}>D</td>
                                                )
                                            }
                                            else if (itemJawaban.JAWABAN_SISWA === "5") {
                                                return (
                                                    <td key={indexJawaban} className={itemJawaban.STATUS_JAWABAN === '1' ? 'text-body center green' : 'text-body center red'} data-attr-id={itemJawaban.ID_BANK_SOAL} style={{ textAlign: 'center' }}>E</td>
                                                )
                                            }
                                            else {
                                                return (
                                                    <td key={indexJawaban} className={itemJawaban.STATUS_JAWABAN === '1' ? 'text-body center green' : 'text-body center red'} data-attr-id={itemJawaban.ID_BANK_SOAL} style={{ textAlign: 'center' }}>-</td>
                                                )
                                            }
                                        }
                                    })
                                }
                            </tr>
                        )
                    })
                }
            </tbody>
        )
    }

    render() {
        require('./homeworkReport.css');

        console.groupCollapsed('CEK State/Props ReportHomeworkDetailJawaban');
        console.info('State', this.state);
        console.info('Props', this.props);
        console.groupEnd();

        return(
            <div className="page">
                <LoaderModal isFetching={this.state.isFetching}/>

                <div className="null" style={{ paddingBottom: '50px' }}>
                    <div className="row">
                        <div className="col-md-8">
                            <p className="judul-atas">SEBARAN PILIHAN JAWABAN SISWA</p>
                            <p className="judul-bawah">REPORT</p>
                            {/* <img src={logo_hw} width="100%"></img> */}
                        </div>

                        <div className="col-md-4">
                            <div class="judul-img">
                                <img class="judul-img" src={logo_eduprime} width="100%"></img>
                            </div>
                        </div>
                    </div>
                    
                    <br></br>
                    <hr/>
                    <div className="row">
                        <div className="col-md-4 header-title-text left">MATA PELAJARAN { this.state.dataSubProfil.namaSubProfil }</div>

                        <div className="col-md-4 header-title-text center">KELAS { this.state.dataKelas }, { this.state.dataGuru.NAMA_SEKOLAH }</div>

                        <div className="col-md-4 header-title-text right">NAMA GURU { this.state.dataGuru.NAMA_GURU }</div>
                    </div>
                    <hr/>

                    <div className="row">
                        <div className="col-md-12">
                            <table className="table table-custom">
                                { this.renderHeadKunciJawaban() }

                                { this.renderBodyKunciJawaban() }
                            </table>

                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <table className="table table-custom">
                                { this.renderHeadJawabanSiswa() }

                                { this.renderBodyJawabanSiswa() }
                            </table>
                        </div>
                    </div>

                    <div className="row footer-text">
                        <div className="col-md-12">
                            <br/>
                        </div>
                        
                        <div className="col-md-3">
                            JUMLAH SISWA
                        </div>

                        <div className="col-md-9">
                            { this.state.dataAllSiswa.length }
                        </div>
                    </div>

                    <div className="row footer-text">
                        <div className="col-md-3">
                            JUMLAH SOAL MULTIPLE
                        </div>

                        <div className="col-md-9">
                            { this.state.dataKunciJawaban.length }
                        </div>
                    </div>
                </div>

                <div className="fixed_button">
                    <button className="btn btn-outline-dark btn133w pull-right" style={{marginRight:'1em'}} onClick={() => window.print()}>Print</button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(ReportHomeworkDetailJawaban);